'use client'

import { useHydrateAtoms } from 'jotai/utils'

import { qrUriAtom } from '../../generatorState'
import { appContentAtom, TAppContent } from './AppContentState'
import { AppScreen } from './AppScreen/AppScreen'

export const AppLandingScreen = ({
	uri,
	content,
}: {
	uri: string
	content: TAppContent
}) => {
	useHydrateAtoms([
		[qrUriAtom, uri],
		[appContentAtom, content],
	])

	return <AppScreen previewMode={false} demoMode={false} />
}
